<nav id="tig-navbar" class="navbar-default navbar-static-side" role="navigation">
	<div class="sidebar-collapse">
		<ul class="nav metismenu" id="side-menu">
			<li class="nav-header" [routerLink]="['/client-selection']">
				<div class="profile-element">
					<!-- client logo -->
					<img *ngIf="client.logo" alt="Logo" class="img-circle" src="{{client?.logo}}"/>
					<div *ngIf="!client.logo" class="img-circle">{{helper_service.getInitials(client.name)}}</div>
					<h1>{{client?.name}}</h1>
				</div>
			</li>
			<ng-container *ngFor="let menu_item of navigation.menuitems">
				<li *ngIf="menu_item.route !== 'profile'" routerLinkActive="active">
					<a href="#"><i class="fa tig-{{menu_item.route}}"></i> <span class="nav-label">{{menu_item?.label || 'oNavigation.' +
					menu_item.route|translate}}</span> <span class="fa arrow"></span> </a>
					<ul class="nav nav-second-level collapse" routerLinkActive="in active">
						<li *ngFor="let sub_menu_item of menu_item.menuitems" routerLinkActive="active" class="tig-menu">
							<a *ngIf="sub_menu_item.type !== 'undefined' && sub_menu_item.type ==='reduceddetail'; else standard"
							   [routerLink]="['/'+ menu_item.route + '/' + sub_menu_item.route + '/reduceddetail' ]">{{getLabel(sub_menu_item)}}
							</a>
							<ng-template #standard>
								<a *ngIf="!sub_menu_item._links.listingconfig; else listing"
								   [routerLink]="['/'+ menu_item.route + '/' + sub_menu_item.route + '/detail/id' ]">{{getLabel(sub_menu_item)}}
								</a>
							</ng-template>
							<ng-template #listing>
								<a *ngIf="!sub_menu_item.nested_listing; else nestedlisting" [routerLink]="['/'+ menu_item.route + '/' + sub_menu_item.route]">{{getLabel(sub_menu_item)}}</a>
							</ng-template>
							<ng-template #nestedlisting>
								<a [routerLink]="['/'+ menu_item.route + '/listing/' + sub_menu_item.route]">{{getLabel(sub_menu_item)}}</a>
							</ng-template>
						</li>
					</ul>
				</li>
				<li *ngIf="menu_item.route === 'profile'" routerLinkActive="active" class="tig-menu">
					<a [routerLink]="['/profile/users']"> <i class="fa fa-user"></i> <span class="nav-label">{{"profile"|translate}}</span> </a>
				</li>
			</ng-container>
		</ul>
	</div>
</nav>
